import { useEffect, useRef } from "react";

const FacebookPageView = () => {
  const lastPathname = useRef(window.location.pathname);

  useEffect(() => {
    const sendPageView = () => {
      if (window.fbq) {
        window.fbq("track", "PageView");
      }
    };

    // Run on initial load
    sendPageView();

    const handleRouteChange = () => {
      const currentPath = window.location.pathname;
      if (lastPathname.current !== currentPath) {
        lastPathname.current = currentPath;
        sendPageView();
      }
    };

    window.addEventListener("popstate", handleRouteChange);
    window.addEventListener("pushstate", handleRouteChange);
    window.addEventListener("replacestate", handleRouteChange);

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
      window.removeEventListener("pushstate", handleRouteChange);
      window.removeEventListener("replacestate", handleRouteChange);
    };
  }, []);

  return null;
};

export default FacebookPageView;
